module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 63
// module chunks = 6